var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"direction":"inherit"}},[_c('div',{staticClass:"pure-g",style:(_vm.style)},[_vm._t("default")],2),_vm._v(" "),(_vm.debug)?_c('Overlay',{attrs:{"cols":_vm.actualNumCols,"gutterWidth":_vm.windowGutter}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }